import "./scss/styles.scss";
//import List from "list-js";
//import Splide from '@splidejs/splide';
//import '@splidejs/splide/css/core';

const initTimeline = () => {
  let bars = [];
  const c = document.querySelectorAll('[data-timeline]');
  if (c && c.length > 0) {
    c.forEach((bar) => {
      const length = bar.dataset.timelineLength;
      const start = bar.dataset.timelineStart;
      const venue = bar.dataset.timelineVenue;
      const startHrs = parseInt(start.slice(0,2));
      const startMin = parseInt(start.slice(3,5));
      const left = (startHrs - 9) * 60 + startMin;
      const found = bars.find(x => x.venue === venue && x.start === start);
      const group = bar.closest('[data-group]').dataset.group;
      let count = 0;
      if (found) {
        count = found.count+=1;
      }
      bar.style.width = length + 'px';
      bar.style.left = left + 'px';
      bar.style.top = count * 16 + 'px';
      const item = {length:length,start:start,venue:venue,count:count,group:group};
      bars.push(item);
    });
    const counts = bars.reduce((p, c) => {
      var name = c.group;
      if (!p.hasOwnProperty(name)) {
        p[name] = 0;
      }
      p[name]++;
      return p;
    }, []);
    counts.forEach((count,index) => {
      document.querySelector('[data-group-opener="'+index+'"] [data-count]').innerHTML = '(' + count + ')';
    });
  }
};

const initTimelineNow = () => {
  const c = document.querySelectorAll('.timeline-data-marker');
  if (c && c.length > 0) {
    c.forEach((marker) => {
      const start = marker.dataset.now;
      if (start && start.length > 0) {
        const startHrs = parseInt(start.slice(0,2));
        const startMin = parseInt(start.slice(3,5));
        const left = (startHrs - 9) * 60 + startMin;
        marker.style.left = left + 'px';
      }
    });
  }
};

const initTabs = () => {
  const c = document.querySelectorAll('.tab');
  if (c && c.length > 0) {
    c.forEach((wrapper) => {
      const tabs = wrapper.querySelectorAll('.tab-item:not(.tab-action)');
      const tabsContent = document.querySelectorAll('.tab-content-item');
      tabsContent[0].style.display = 'block';
      tabs.forEach((tab, index) => {
        tab.style.cursor = 'pointer';
        tab.addEventListener('click', (event) => {
          tabs.forEach((t) => {
            t.classList.remove('active');
          });
          event.target.classList.add('active');
          tabsContent.forEach((t) => {
            t.style.display = 'none';
          });
          tabsContent[index].style.display = 'block';
        });
      });
    });
  }
};

const loadFussballde = (id) => {
  loadScript('//www.fussball.de/static/layout/fbde2/egm//js/widget2.js')
  .then(data => {
    new fussballdeWidgetAPI().showWidget('widget-' + id, id);
  })
  .catch(err => {
    console.error(err);
  });
};

const initFussballdeDSGVO = () => {
  if (document.querySelectorAll('[data-fussballde-container]').length > 0) {
    var c = document.querySelectorAll('[data-fussballde-container]');
    var total = c.length;
    for (var i=0; i<total; i++) {
      var el = c[i].querySelector('[data-fussballde-button]');
      showFussballdeDSGVO(el,c[i]);
    }
  }
};
const showFussballdeDSGVO = (el,c) => {
  var show_fussballde = sessionStorage.getItem("show_fussballde");

  el.addEventListener('click', function(event) {
    // check if user wants to save the decision
    var remember = c.querySelector('[data-fussballde-button-remember]');
    if (remember.checked) {
      sessionStorage.setItem("show_fussballde", "true");
    }
    loadFussballde(el.id);
    event.stopPropagation();
  });

  if (show_fussballde && show_fussballde === 'true') {
    loadFussballde(el.id);
  }
};
const loadScript = (FILE_URL, async = true, type = "text/javascript") => {
  return new Promise((resolve, reject) => {
    try {
      const scriptElem = document.createElement("script");
      scriptElem.type = type;
      scriptElem.async = async;
      scriptElem.src =FILE_URL;
      scriptElem.addEventListener("load", (ev) => {
        resolve({ status: true });
      });
      scriptElem.addEventListener("error", (ev) => {
        reject({
          status: false,
          message: `Failed to load the script ${FILE_URL}`
        });
      });
      document.body.appendChild(scriptElem);
    } catch (error) {
      reject(error);
    }
  });
};

const initSearchField = () => {
  const el = document.getElementById('search');
  if (el) {
    el.addEventListener('input',() => {
      window.history.pushState('', '', '?q=' + encodeURIComponent(el.value));
    });
  }
};
const initToggleTimelineTrainings = () => {
  const el = document.getElementById('trainings');
  const target = document.querySelector('.timeline');
  if (el && target) {
    el.addEventListener('change',() => {
      target.classList.toggle('timeline-show-trainings');
    });
  }
};

function initFussballdeWidget() {
  const widgets = document.querySelectorAll('[data-fussballde]');
  if (typeof fussballdeWidgetAPI != 'undefined') {
    widgets.forEach((el) => {
      const id = el.id;
      const wId = id.replace('widget-','');
      new fussballdeWidgetAPI().showWidget(id, wId);
    });
  }
}

function initEvents(list) {
  // default hide trainings
  hideTraining(list);
  const checkboxTraining = document.querySelector('[data-filter="training"]');
  document.body.addEventListener('click', function(event) {
    if (event.target.parentElement.dataset.groupOpener) {
      var i = event.target.parentElement.dataset.groupOpener;
      event.target.parentElement.classList.toggle('group-open');
      var elements = document.querySelectorAll('[data-group="' + i + '"]');
      if (elements.length) {
        elements.forEach((el) => {
          el.classList.toggle('d-none');
        });
      }
    }
    if (list) {
      if (event.target.type && event.target.type === 'checkbox') {
        event.target.classList.toggle('unchecked');
        if (event.target && event.target.dataset.filter) {
          if (checkboxTraining && checkboxTraining.checked) {
            resetFilter(list);
          } else {
            hideTraining(list);
          }
        }
      }
    }
  });
}

function hideTraining(list) {
  if (list) {
    list.filter((item) => {
      if (
        item.values().headline.includes('Staufen Training')
        || item.values().headline.includes('Herren Training')
        || item.values().headline.includes('Frauen Training')
        || item.values().headline.includes('Junioren Training')
        || item.values().headline.includes('Juniorinnen Training')
        || item.values().headline.includes('2 Training')
        || item.values().headline.includes('IL Training')
      ) {
        return false;
      } else {
        return true;
      }
    });
  }
}

function resetFilter(list) {
  if (list) {
    list.filter();
  }
}

function openPopup(url) {
  console.log(url);
  let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=800,height=600,left=100,top=100`;
  document.open(url, 'editimport', params);
}

function getPosition(el) {
  var rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
  };
}

function checkTopPosition(top) {
  var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
  if (scrollTop < top) {
    document.body.setAttribute('data-scrolled','false');
  } else {
    document.body.setAttribute('data-scrolled','true');
  }
}

function toggleBodyClass() {
  var selector = 'data-togglebody';
  if (document.querySelectorAll('['+selector+']').length > 0) {
    var total = document.querySelectorAll('['+selector+']').length;
    for (var i=0; i<total; i++) {
      var el = document.querySelectorAll('['+selector+']')[i];
      var classname = el.getAttribute(selector);
      adds(el, classname);
    }
  }
}
function adds(el,classname) {
  el.addEventListener('click', function(event) {
    event.stopPropagation();
    document.body.classList.toggle(classname);
  });
}

(() => {
  document.body.parentNode.classList.add('js');
  document.body.parentNode.classList.remove('no-js');

  toggleBodyClass();
  initTabs();
  initTimeline();
  initTimelineNow();
  initFussballdeDSGVO();
  initSearchField();
  initToggleTimelineTrainings();

  const elTermine = document.querySelector('#termine .list');
  const elTermineSearch = document.querySelector('#termine .search');
  let termine = null;
  if (elTermine) {
    termine = new List('termine', {
      valueNames: [{ name: 'date', attr: 'data-date' }, 'headline', 'text', 'notes', 'team']
    });
    if (elTermineSearch && elTermineSearch.value.length > 1) {
      termine.search(elTermineSearch.value);
    }

    const showSearchForm = (size,showAlways=false) => {
      const elSize = document.querySelector('#termine .size');
      const elSearchForm = document.querySelector('#termine .search-form');
      elSearchForm.classList.remove('hidden');
      if (!showAlways && size < 10) {
        elSearchForm.classList.add('hidden');
      }
      let sizeText = size + ' Veranstaltungen gefunden';
      if (size === 1) {
        sizeText = '1 Veranstaltung gefunden';
      }
      elSize.innerHTML = sizeText;
    }

    showSearchForm(termine.matchingItems.length);

    termine.on("updated",function() {
      showSearchForm(termine.matchingItems.length,true);
    });
  }

  const elDownloads = document.querySelector('#downloads .list');
  if (elDownloads) {
    const downloads = new List('downloads', {
      valueNames: ['name', { name: 'lastmod', attr: 'data-lastmod' }, { name: 'filesize', attr: 'data-filesize' }]
    });
  }

  initFussballdeWidget();
  initEvents(termine);

  var navbars = document.getElementsByClassName('nav');
  if (navbars.length > 0) {
    var nav = navbars[0];
    var top = getPosition(nav).top;
    checkTopPosition(top);
    window.onscroll = function() {
      checkTopPosition(top);
    };
  }
})();
